import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const ScheduleItem = ({ title, rows }) => (
    <Box sx={{ backgroundColor: (th) => th.palette.grey.light, pt: 1, px: 1, my: 1 }}>
        <Grid container spacing={1}>
            <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 'bold', pb: 1 }}>
                    {title}
                </Typography>
            </Grid>
            <Grid item xs={6} justifyContent="flex-end">
                {Array.isArray(rows) && rows.length > 0 ? (
                    rows.map((row, index) => (
                        <Typography key={`row_key${index * 2}`} variant="body2" align="right" sx={{ pb: 1 }}>
                            {row}
                        </Typography>
                    ))
                ) : (
                    <Typography variant="body2" align="right" sx={{ pb: 1 }}>
                        Closed
                    </Typography>
                )}
            </Grid>
        </Grid>
    </Box>
);

export default ScheduleItem;
